import { Heart, Feather } from 'lucide-react';
import { LOVE_LETTER, MY_NAME } from '@/config/valentineContent';

export default function LoveLetter() {
  return (
    <section id="love-letter" data-testid="love-letter-section" className="section-romantic">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-3">
          <p className="font-body text-[10px] tracking-widest uppercase mb-2" style={{ color: 'var(--accent-light)' }}>
            {LOVE_LETTER.sectionLabel}
          </p>
          <h2 className="font-heading text-2xl md:text-3xl mb-2" style={{ color: 'var(--text-primary)' }}>
            {LOVE_LETTER.heading}
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-12 h-[1px]" style={{ background: 'linear-gradient(90deg, transparent, var(--accent-light))' }} />
            <Feather size={12} style={{ color: 'var(--accent-primary)' }} />
            <div className="w-12 h-[1px]" style={{ background: 'linear-gradient(90deg, var(--accent-light), transparent)' }} />
          </div>
        </div>

        <div className="letter-card relative rounded-2xl overflow-hidden"
          style={{ backgroundColor: 'var(--bg-card)', border: '1.5px solid var(--accent-glow)', boxShadow: '0 8px 40px var(--accent-glow)' }}>
          <div className="h-1" style={{ background: 'linear-gradient(90deg, transparent, var(--accent-primary), transparent)' }} />
          <span className="letter-corner letter-corner-tl" style={{ color: 'var(--accent-light)' }}>&#10087;</span>
          <span className="letter-corner letter-corner-tr" style={{ color: 'var(--accent-light)' }}>&#10087;</span>
          <span className="letter-corner letter-corner-bl" style={{ color: 'var(--accent-light)' }}>&#10087;</span>
          <span className="letter-corner letter-corner-br" style={{ color: 'var(--accent-light)' }}>&#10087;</span>

          <div className="p-8 md:p-12 relative">
            <div className="flex items-center justify-between mb-6">
              <span className="font-body text-[10px] tracking-widest uppercase" style={{ color: 'var(--accent-light)' }}>
                {LOVE_LETTER.date}
              </span>
              <Heart size={12} fill="var(--accent-primary)" strokeWidth={0} />
            </div>

            <p className="font-heading text-lg mb-6" style={{ color: 'var(--text-primary)' }}>
              {LOVE_LETTER.salutation}
            </p>

            <div className="space-y-5 mb-8">
              {LOVE_LETTER.paragraphs.map((p, i) => (
                <div key={i}>
                  {i === 0 ? (
                    <p className="font-body text-sm md:text-base leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                      <span className="letter-drop-cap font-heading float-left mr-2 leading-none"
                        style={{ color: 'var(--accent-primary)', fontSize: '3rem', lineHeight: '0.8' }}>
                        {p.charAt(0)}
                      </span>
                      {p.slice(1)}
                    </p>
                  ) : (
                    <p className="font-body text-sm md:text-base leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                      {p}
                    </p>
                  )}
                  {i === 0 && (
                    <div className="flex items-center justify-center gap-4 py-3">
                      <div className="w-8 h-[1px]" style={{ background: 'var(--accent-glow)' }} />
                      <span className="text-[8px]" style={{ color: 'var(--accent-light)' }}>&#10047;</span>
                      <div className="w-8 h-[1px]" style={{ background: 'var(--accent-glow)' }} />
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="letter-divider mb-6" />

            <div className="flex items-end justify-between">
              <div>
                <p className="font-body text-xs mb-2" style={{ color: 'var(--text-secondary)' }}>{LOVE_LETTER.closing}</p>
                <p className="font-cursive text-2xl md:text-3xl" style={{ color: 'var(--accent-primary)' }}>{MY_NAME}</p>
              </div>
              <div className="letter-wax-seal flex-shrink-0">
                <div className="letter-wax-inner">
                  <Heart size={16} fill="#fff" strokeWidth={0} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
